/**
 *
 * Usage:
 *
 *   data-sw-select-url="<URL_PATH>"
 *
 * Events:
 *   @navigates to target url <URL_PATH>
 *
 */

var $ = require('./../sw-jquery');

$(function() {
    $('body').on('change', '[data-sw-select-url]', function() {
        var $el = $(this);
        if ($el.is('select')) {
            window.location.href = $el.val();
        }
    });
});